import styled, { css } from "styled-components"

import { elementCss, ElementProps } from "components/shared/base/Element"

export type TextProps = ElementProps

export const textCss = css`
  ${elementCss};
`

const Text = styled.div<TextProps>`
  ${textCss};
`
export default Text
